import { Injectable } from '@angular/core';
import { GameOverService } from '@fantaz/shared/data-access/api';
import { ToastService } from '@fantaz/shared/utils/toast';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { asyncScheduler, catchError, of, switchMap, throttleTime } from 'rxjs';
import * as GameOverActions from './game-over.actions';

@Injectable()
export class GameOverEffects {
  init$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GameOverActions.loadGameOver),
        throttleTime(2000, asyncScheduler, { leading: true, trailing: true }),
        switchMap(
          ({
            playInstance,
            userUuid,
            pageIndex,
            pageSize,
            paginated,
            extra,
          }) => {
            return this.gameOverService
              .getGameOver(
                playInstance,
                userUuid,
                pageIndex,
                pageSize,
                paginated,
                extra,
              )
              .pipe(
                switchMap((gameOver) => {
                  return [
                    GameOverActions.loadGameOverSuccess({
                      gameOver,
                      playInstanceId: playInstance,
                    }),
                  ];
                }),
              );
          },
        ),

        catchError((error) => {
          if (error.status && error.status === 403) {
            // show denied message
            this.toastService.openSnackBar(
              'You do not have permission to access the requested resource.',
              { action: '', duration: 5000 },
            );

            // redirect to tournament list when user not have permission to view
            // game over result
            window.location.href = '/tournaments';
          }

          return of(GameOverActions.loadGameOverFailure({ error }));
        }),
      ),
    { dispatch: true },
  );

  constructor(
    private readonly actions$: Actions,
    private gameOverService: GameOverService,
    private readonly toastService: ToastService,
  ) {}
}
